// extracted by mini-css-extract-plugin
module.exports = {"formSection":"styles_formSection__2RAZd"};